export default __webpack_public_path__ + "static/media/empty-transaction.df04d416.png";